import React, { useEffect, useState } from "react";
import {
  Table,
  Card,
  Input,
  Button,
  Row,
  Col,
  Modal,
  Form
} from "antd";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const Position = () => {
  const [positions, setPositions] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [form] = Form.useForm();

  const navigate = useNavigate();
  const token = localStorage.getItem("access-token");

  // ================= FETCH =================
  const fetchPositions = () => {
    axios
      .get("http://localhost:5000/api/positions", {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then((res) => setPositions(res.data))
      .catch((err) => console.error(err));
  };

  useEffect(() => {
    fetchPositions();
  }, []);

  // ================= ADD POSITION =================
  const handleAddPosition = () => {
    form.validateFields().then((values) => {
      axios
        .post("http://localhost:5000/api/positions", values, {
          headers: { Authorization: `Bearer ${token}` }
        })
        .then(() => {
          setIsModalOpen(false);
          form.resetFields();
          fetchPositions(); // refresh table
        })
        .catch((err) => console.error(err));
    });
  };

  // ================= SEARCH FILTER =================
  const filteredData = positions.filter((item) =>
    item.position.toLowerCase().includes(searchText.toLowerCase())
  );

  // ================= TABLE COLUMNS =================
  const columns = [
    {
      title: "SL",
      render: (_, __, index) => index + 1
    },
    {
      title: "Position",
      dataIndex: "position"
    },
    {
      title: "Details",
      dataIndex: "details"
    }
  ];

  // ================= UI =================
  return (
    <Card title="Position">
      {/* 🔥 Top Controls */}
      <Row justify="space-between" style={{ marginBottom: 16 }}>
        <Col>
          <Input
            placeholder="Search Position"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            style={{ width: 200 }}
          />
        </Col>

        <Col>

          <Button
            type="primary"
            onClick={() => setIsModalOpen(true)}
          >
            Add Position
          </Button>
          
          <Button
            style={{ marginRight: 10 }}
            onClick={() => navigate("/admin/manage-position")}
          >
            Manage Position
          </Button>

          
        </Col>
      </Row>

      {/* ✅ Table */}
      <Table
        dataSource={filteredData}
        columns={columns}
        rowKey="_id"
        pagination={{ pageSize: 5 }}
      />

      {/* ✅ Add Position Modal */}
      <Modal
        title="Add Position"
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        onOk={handleAddPosition}
        okText="Save"
      >
        <Form form={form} layout="vertical">
          <Form.Item
            label="Position"
            name="position"
            rules={[{ required: true, message: "Please enter position" }]}
          >
            <Input placeholder="Position" />
          </Form.Item>

          <Form.Item label="Details" name="details">
            <Input.TextArea placeholder="Details" />
          </Form.Item>
        </Form>
      </Modal>
    </Card>
  );
};

export default Position;